import {
	getModule,
	Module,
	VuexModule,
	Mutation,
	Action,
} from 'vuex-module-decorators';
import store from '@/store';
import accountz from '../accountz';
import {
	AccountData, ValueText,
	PermissionsData,
	AddRemoveAccountUserSubmission,
	SetPermmissionSubmission,
	PermissionsGroup,
	CommandData,
	DownloadFormat,
} from '../models.def';
import { Dictionary } from 'vue-router/types/router';
@Module({
	namespaced: true,
	name: 'accountx',
	store,
	dynamic: true,
})
class MediumwaresModule extends VuexModule {

	public currentAccount: AccountData | null = null;
	public currentAccountPermissions: PermissionsData = {};
	public currentAccountLastLogins: Dictionary<number> = {};

	public currentAccountId: string | null = null;

	public commands: CommandData[] = [];

	public get softwareTypesVt(): ValueText[] {
		return [
			{ value: 'sql', text: 'SQL' },
			{ value: 'autocount', text: 'AutoCount' },
		];
	}

	public get numAdmins(): number {
		let num = 0;
		for (const email in this.currentAccountPermissions) {
			if (this.currentAccountPermissions.hasOwnProperty(email)) {
				const user = this.currentAccountPermissions[email];
				if (user.admin) {
					num++;
				}
			}
		}
		return num;
	}

	@Mutation
	public m_updateCurrentAccount(account: AccountData | null) {
		this.currentAccount = account;
	}
	@Mutation
	public m_updateCurrentAccountPermissions(permissions: PermissionsData) {
		this.currentAccountPermissions = permissions;
	}
	@Mutation
	public m_updateCurrentAccountCommands(commands: CommandData[]) {
		this.commands = commands;
	}
	@Mutation
	public m_updateCurrentAccountLastLogins(lastLogins: Dictionary<number>) {
		this.currentAccountLastLogins = lastLogins;
	}
	@Mutation
	public m_updateCurrentAccountId(accountId: string) {
		this.currentAccountId = accountId;
	}

	@Action public updateCurrentAccount(account: AccountData | null) {
		this.m_updateCurrentAccount(account);
	}
	@Action public updateCurrentAccountPermissions(permissions: PermissionsData) {
		this.m_updateCurrentAccountPermissions(permissions);
	}
	@Action
	public updateCurrentAccountId(accountId: string) {
		this.m_updateCurrentAccountId(accountId);
	}
	@Action
	public updateCurrentAccountCommands(commands: CommandData[]) {
		this.m_updateCurrentAccountCommands(commands);
	}
	@Action public updateCurrentAccountLastLogins(lastLogins: Dictionary<number>) {
		this.m_updateCurrentAccountLastLogins(lastLogins);
	}

	@Action
	public async addRemoveAccountUser(submission: AddRemoveAccountUserSubmission) {
		const result = await accountz.addRemoveAccountUser(submission);
		return result;
	}
	@Action
	public async setPermissions(submission: SetPermmissionSubmission) {
		const result = await accountz.setPermissions(submission);
		return result;
	}
	@Action
	public async downloadZip(payload: { group: PermissionsGroup; format: DownloadFormat }) {
		const result = await accountz.downloadZip(payload.group, payload.format);
		return result;
	}
	@Action
	public async downloadAllZips(payload: {
		format: DownloadFormat;
		onProgress?: (current: number, total: number, group: string) => void;
	}) {
		const result = await accountz.downloadAllZips(payload.format, payload.onProgress);
		return result;
	}

}


export default getModule(MediumwaresModule);
